import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
} from "reactstrap";
import { useEffect, useRef, useState, startTransition } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import Header from "components/Headers/Header";
import { FaPaperclip } from "react-icons/fa";

// Hook personalizado para intervalos
const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay !== null) {
      const id = setInterval(() => savedCallback.current(), delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

const AdjuntosCargadosIndex = (props) => {
  const [list1, setList1] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);

  const urlendpoint =
    "https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerAnexosOrden/" +
    props.OrdenId;

  const fetchData = () => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: urlendpoint,
    })
      .then((response) => {
        setList1(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Recarga periódica solo si el modal está abierto
  useInterval(
    () => {
      if (modalIsOpen) fetchData();
    },
    modalIsOpen ? 6000 : null,
  );

  useEffect(() => {
    if (modalIsOpen) fetchData();
  }, [modalIsOpen]);

  const handleOpenModalTest = () => {
    startTransition(() => {
      setIsOpen(true);
    });
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        variant="contained"
        className="btn btn-primary btn-lg"
        color="primary"
        onClick={handleOpenModalTest}
        title="Anexos"
      >
        <FaPaperclip style={{ marginRight: "0px" }} />
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Anexos Cargados"
        ariaHideApp={false}
        style={{
          content: {
            inset: "40px",
            padding: "0",
            border: "none",
            borderRadius: "8px",
            overflow: "hidden", // evita scroll global en modal
          },
        }}
      >
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h3 className="mb-0">Anexos cargados</h3>
                </CardHeader>

                {/* ✅ Scroll SOLO aquí */}
                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">AnexoId</th>
                        <th scope="col">URL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list1.map((item) => (
                        <tr key={item.id}>
                          <td>{item.adjunto}</td>
                          <td>
                            <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Descargar Archivo Anexo
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination className="pagination justify-content-end mb-0">
                      <PaginationItem className="disabled">
                        <PaginationLink
                          href="#"
                          onClick={(e) => e.preventDefault()}
                          tabIndex="-1"
                        >
                          <i className="fas fa-angle-left" />
                          <span className="sr-only">Previous</span>
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem className="active">
                        <PaginationLink
                          href="#"
                          onClick={(e) => e.preventDefault()}
                        >
                          1
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          href="#"
                          onClick={(e) => e.preventDefault()}
                        >
                          2
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          href="#"
                          onClick={(e) => e.preventDefault()}
                        >
                          3
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          href="#"
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fas fa-angle-right" />
                          <span className="sr-only">Next</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default AdjuntosCargadosIndex;
